import { OPTIME_SOLUTIONS_URL } from "../../../utils/url/staticUrls";
import { Trans, useTranslation as useTranslation } from "react-i18next";
import { Alert } from "~/common/m3/Alert/Alert";

const OptimeSolutionsMessage = ({ className }: { className?: string }) => {
  useTranslation();

  return (
    <Alert severity="info" className={className}>
      <Trans
        i18nKey="productDetailsPage.purchaseCard.requiresDigitalSecrvice"
        components={{ a: <a href={OPTIME_SOLUTIONS_URL} target="_blank" rel="noopener noreferrer" /> }}
      />
    </Alert>
  );
};
export default OptimeSolutionsMessage;
